import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useServer } from '../contexts/ServerContext';
import { LogIn } from 'lucide-react';

function Login() {
  const { login } = useAuth();
  const { servers, server, setServer, loading } = useServer();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gmod-dark">
      <div className="max-w-md w-full space-y-8 p-8 bg-gmod-dark border border-gmod-lighterer rounded-xl shadow-lg">
        <div className="text-center">
          <div className="mx-auto h-16 w-16 bg-theme-primary rounded-full flex items-center justify-center mb-4">
            <LogIn className="h-8 w-8 text-gmod-white" />
          </div>
          <h2 className="text-3xl font-bold text-gmod-white mb-2">
            yufu.su
          </h2>
          <p className="text-gmod-white opacity-60">
            Войдите через Steam для доступа к панели администратора
          </p>
        </div>

        <div className="mt-8">
          <button
            onClick={() => window.location.href = `/api/auth/steam?server=${server}`}
            className="group relative w-full flex justify-center py-3 px-4 border border-theme-primary text-sm font-medium rounded-md text-gmod-white bg-theme-primary hover:bg-theme-primary-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme-primary transition-colors duration-200"
          >
            <LogIn className="w-5 h-5 mr-2" />
            Войти через Steam
          </button>
        </div>
        <div className="mt-6 text-center">
          <p className="text-sm text-gmod-white opacity-60">
            Только персонал сервера может получить доступ
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login; 